// src/data/default.tsx
import { getBaseUrl } from "@/utils/getBaseUrl";

const baseUrl = getBaseUrl();

export const site = {
  name: "Grasitech",
  siteName: "Grasitech",
  companyName: "PT Gratia Global Solution",
  author: "Cloud Studio Bekasi",
  url: baseUrl,
  baseUrl: baseUrl,
  altUrl: "https://grasitech.com",
  phone: "(+62) 877-8484-2525",
  whatsapp: "6287784842525",
  mailCS: "cs@grasi.id",
  mailInfo: "info@grasi.id",
  mailAdmin: "admin@grasi.id",
  address: "Menara 165 Lantai 14 Unit E, Jl. T.B. Simatupang, Kav.01 RT 003/003, Cilandak Timur, Pasar Minggu Jakarta Selatan, Jakarta - Indonesia",
  title: "Sewa Laptop Terdekat | Jakarta Bogor Depok Tangerang Bekasi",
  description: "Sewa Laptop murah terlengkap - Langsung Antar ke Lokasi Anda di Jabodetabek! Cocok untuk kantor, event, atau sekolah. Harian, mingguan, bulanan.",
  tagline: "Sewa Laptop ✓ Harian ✓ Mingguan ✓ Bulanan. Jakarta, Bekasi, Tangerang, Depok, Bogor.",
  short_description: "Pusat Penyewaan Laptop Terbaik & Terlengkap untuk Kantor, Event & Sekolah. Durasi Rental Harian, Mingguan, Bulanan.",
  image: "/images/grasitech.png",
  keywords: ["sewa laptop", "rental laptop", "laptop harian", "laptop mingguan", "laptop bulanan", "jakarta", "bekasi", "tangerang", "depok", "bogor", "jabodetabek", "grasitech"],
  robots: "index, follow",
  icons: {
    icon: "/images/icon.png",
    favicon: "/favicon.ico",
  },
  manifest: "/site.webmanifest",
  theme: {
    color: "#0074DD",
    background: "#ffffff",
  },
  sosmed: {
    facebook: { url: "https://fb.me/meryza.sari.7", icon: "FaFacebook" },
    instagram: { url: "https://www.instagram.com/grasi_tech", icon: "FaInstagram" },
    twitter: { url: "https://twitter.com/grasitech", icon: "FaTwitter" },
    //linkedin: { url: "https://linkedin.com/in/grasitech", icon: "FaLinkedin" },
    youtube: { url: "https://youtube.com/@grasitech", icon: "FaYoutube" },
    tiktok: { url: "https://tiktok.com/@grasitech", icon: "SiTiktok" },
  }
};